import React, { useState, useEffect } from 'react'

import styles from './styles.module.scss'

import EmployeeView from '../EmployeeView'

import { getCompanyWorkTimeSettings, getCompanyTimeOffs } from '../../../api'
import { useQuery } from '../../../hooks/useQuery'

const MyTimeOffSection = ({ companyId, employee }) => {
  const employeeId = employee.id

  const { tab, timeOffId, policyId, view } = useQuery(['tab:time_off', 'timeOffId', 'policyId', 'employeeId', 'view:requests'])

  const [timeOffs, setTimeOffs] = useState([])
  const [workTimeSettings, setWorkTimeSettings] = useState({})

  const holidaysMap = [...(workTimeSettings.work_time?.holidays || []), ...(workTimeSettings.national_holidays || [])].reduce((acc, holiday) => ({
    ...acc,
    [holiday.date]: true,
  }), {})

  const timeOffsMap = timeOffs.reduce((acc, timeOff) => ({
    ...acc,
    [timeOff.id]: timeOff,
  }), {})

  useEffect(() => {
    if (companyId) {
      init(companyId)
    }
  }, [companyId])

  const init = async (companyId) => {
    const [timeOffsRes, workTimeSettings] = await Promise.all([
      getCompanyTimeOffs(companyId),
      getCompanyWorkTimeSettings(companyId),
    ])

    if (Array.isArray(timeOffsRes)) {
      setTimeOffs(timeOffsRes)
    }
    setWorkTimeSettings(workTimeSettings)
  }

  return (
    <div className={styles.container}>
      <EmployeeView
        isMe={true}
        tab={tab}
        companyId={companyId}
        timeOffId={timeOffId}
        policyId={policyId}
        employeeId={employeeId}
        view={view}
        employee={employee}
        timeOffs={timeOffsMap}
        holidays={holidaysMap} />
    </div>
  )
}

export default MyTimeOffSection
